import styled from 'styled-components';

export const StoreCardsListContainer = styled.div`
  /* add spacing between cards in list */
  > * {
    margin-bottom: 0.2rem;
  }
`;
